import React, { useEffect, useState, useCallback,  useRef, useMemo } from "react";
import { useParams } from "react-router-dom";
import api from "../services/api";
import { format, addDays, subDays, parseISO } from "date-fns";
import "./CashEntriesPage.css";
import { MdClose } from "react-icons/md";
import { TbArrowBigLeftFilled } from "react-icons/tb";
import { TbArrowBigRightFilled } from "react-icons/tb";
import Papa from "papaparse";


const CashEntriesPage = () => {
  const { id: businessId } = useParams();
  const [categories, setCategories] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [entryData, setEntryData] = useState({});
  const [cashAdvanceData, setCashAdvanceData] = useState({});
  const [currentDate, setCurrentDate] = useState(new Date());
  const [tempEntryData, setTempEntryData] = useState({});
  const [tempCashAdvanceData, setTempCashAdvanceData] = useState({});

  const [showDatePicker, setShowDatePicker] = useState(false);
const [startDateInput, setStartDateInput] = useState(format(new Date(), "yyyy-MM-dd"));

  

  const [showAddCat, setShowAddCat] = useState(false);
const [showEditCat, setShowEditCat] = useState(false);

const [newCat, setNewCat] = useState({ name: "", category_type: "" });
const [editCat, setEditCat] = useState({ id: "", name: "", category_type: "" });

const CATEGORY_TYPES = [
   { value: "income", label: "income" },
   { value: "non-sale", label: "non-sale income" }, // UI label only
   { value: "payment", label: "payment" },
   { value: "paidouts", label: "paidouts" },
   { value: "refunds", label: "refunds" },
 ];
const RESERVED = new Set(["Open Cash", "Close Cash", "Required Cash", "Cash Advance"]);

const inputRefs = useRef({});





  //const navigate = useNavigate();

  const daysToShow = [-3, -2, -1, 0, 1, 2, 3].map(offset =>
    format(addDays(currentDate, offset), "yyyy-MM-dd")
  );

  const loadCategories = useCallback(async () => {
    try {
      const { data } = await api.get(`/cash-register-categories`, {
        params: { business_id: businessId },
      });
      setCategories(data);
     
      
    } catch (err) {
      console.error("Error fetching categories:", err);
      alert("Failed to load categories");
    }
  }, [businessId]);


  const rowIds = useMemo(() => {
  const byType = (t) => categories.filter((c) => c.category_type === t);

  const tillSorted = byType("till").slice().sort((a, b) => {
    const orderNames = ["Open Cash", "Close Cash"];
    return orderNames.indexOf(a.name) - orderNames.indexOf(b.name);
  });

  const order = [
    ...tillSorted,
    ...byType("income"),
    ...byType("non-sale"),
    ...byType("payment"),
    ...byType("paidouts"),
    ...byType("refunds"),
  ].filter((c) => c.name !== "Cash Advance" && c.name !== "Required Cash");

  return order.map((c) => c.id);
}, [categories]);


const handleKeyDown = useCallback(
  (e, catId, date) => {
    const key = e.key;
    const goDown = key === "Enter" || (key === "Tab" && !e.shiftKey);
    const goUp = key === "Tab" && e.shiftKey;
    if (!goDown && !goUp) return;

    e.preventDefault();

    if (!rowIds.length) return;
    const curIndex = rowIds.indexOf(catId);
    if (curIndex === -1) return;

    const isCellEmpty = (catId, date) => {
      const k = `${catId}_${date}`;
      // empty input exists only when:
      // - there is no saved entry for that key
      // - and no temp value exists
      // (in that case your render shows <input value=""> and we register a ref)
      return !entryData[k] && tempEntryData[k] === undefined && !!inputRefs.current[k];
    };

    let idx = curIndex;
    let steps = 0;

    while (steps < rowIds.length) {
      idx = goDown ? (idx + 1) % rowIds.length : (idx - 1 + rowIds.length) % rowIds.length;
      const nextCatId = rowIds[idx];
      if (isCellEmpty(nextCatId, date)) {
        const nextEl = inputRefs.current[`${nextCatId}_${date}`];
        if (nextEl) {
          nextEl.focus();
          if (typeof nextEl.select === "function") nextEl.select();
        }
        return;
      }
      steps += 1;
    }
    // If no empty inputs in this column, do nothing.
  },
  [rowIds, entryData, tempEntryData]
);



  const loadEmployees = useCallback(async () => {
    try {
      const { data } = await api.get(`/load-employees`, {
        params: { business_id: businessId },
      });
      setEmployees(data);
    } catch (err) {
      console.error("Error fetching employees:", err);
      alert("Failed to load employees");
    }
  }, [businessId]);



  useEffect(() => {
  // wipe UI-only buffers when the business changes
  setEntryData({});
  setCashAdvanceData({});
  setTempEntryData({});
  setTempCashAdvanceData({});
}, [businessId]);


  const loadEntries = useCallback(async () => {
    try {
      const startDate = format(addDays(currentDate, -3), "yyyy-MM-dd");
      const endDate = format(addDays(currentDate, 3), "yyyy-MM-dd");

      const { data } = await api.get("/cash-register-entries", {
        params: { business_id: businessId, start_date: startDate, end_date: endDate },
      });

      const newEntryData = {};
      const newCashAdvanceData = {};

      data.forEach(entry => {
        const dateKey = format(new Date(entry.entry_date), "yyyy-MM-dd");
        const key = `${entry.category_id}_${dateKey}`;

        if (entry.category_name === "Cash Advance") {
          if (!newCashAdvanceData[dateKey]) newCashAdvanceData[dateKey] = [];
          newCashAdvanceData[dateKey].push({
            id: entry.id,
            employee_id: entry.employee_id,
            amount: entry.amount,
            employee_name: entry.employee_name,
          });
        } else {
          newEntryData[key] = { id: entry.id, amount: entry.amount };
        }
      });


           const openCashCat  = categories.find(c => c.name === "Open Cash");
     const closeCashCat = categories.find(c => c.name === "Close Cash");

     const prefills = {};
     if (openCashCat && closeCashCat) {
       // 7-day window around currentDate
       const days = [-3, -2, -1, 0, 1, 2, 3].map(offset =>
         format(addDays(currentDate, offset), "yyyy-MM-dd")
       );

       for (let i = 0; i < days.length; i++) {
         const date = days[i];
         const prevDate = format(subDays(parseISO(date), 1), "yyyy-MM-dd");

         const closeKeyPrev = `${closeCashCat.id}_${prevDate}`;
         const openKeyCurr  = `${openCashCat.id}_${date}`;

         const closeSaved = newEntryData[closeKeyPrev]?.amount;

         // Prefill only if:
         //  - there is a saved Close Cash yesterday,
         //  - there is NO saved Open Cash today,
         //  - and there is NO temp value already for today's Open Cash
                 if (closeSaved !== undefined && newEntryData[openKeyCurr] === undefined) {
          prefills[openKeyCurr] = Number(closeSaved).toFixed(2);
        }
       }
     }
     // ------------------------------------------------------------------------

      setEntryData(newEntryData);
      setCashAdvanceData(newCashAdvanceData);
    if (Object.keys(prefills).length) {
      setTempEntryData(prev => {
        const updated = { ...prev };
        for (const [key, val] of Object.entries(prefills)) {
          // don’t overwrite if user already typed something
          if (updated[key] === undefined) {
            updated[key] = val;
          }
        }
        return updated;
      });
    }
           
    } catch (err) {
      console.error("Error loading entries:", err);
      alert("Failed to load saved entries");
    }
  }, [businessId, currentDate, categories]);

  

  // 1) Fetch categories + employees when business changes
useEffect(() => {
  loadCategories();   // depends only on businessId
  loadEmployees();    // depends only on businessId
}, [loadCategories, loadEmployees]);

useEffect(() => {
  if (!categories.length) return;  // ensure we have categories first
  loadEntries();                   // depends on businessId, currentDate, categories
}, [businessId, currentDate, categories, loadEntries]);

  const handleInputChange = (categoryId, date, value) => {
    const key = `${categoryId}_${date}`;
    setTempEntryData(prev => ({ ...prev, [key]: value }));
  };

  const handleCashAdvanceChange = (date, index, field, value) => {
    setTempCashAdvanceData(prev => {
      const updated = { ...prev };
      if (!updated[date]) updated[date] = [];
      if (!updated[date][index]) updated[date][index] = {};
      updated[date][index][field] = value;
      return updated;
    });
  };

  const addCashAdvanceRow = (date) => {
    setTempCashAdvanceData(prev => {
      const updated = { ...prev };
      if (!updated[date]) updated[date] = [];
      updated[date].push({ employee_id: "", amount: "" });
      return updated;
    });
  };

  function calculateRequiredCash(entryDataByCat, cashAdvanceTotal, categories) {
  const findCatByName = (name) => categories.find((c) => c.name === name);
  const getAmount = (name) => {
    const cat = findCatByName(name);
    return cat ? parseFloat(entryDataByCat[cat.id] || 0) : 0;
  };

  const openAmount = getAmount("Open Cash");
  const closeAmount = getAmount("Close Cash");

  const sumByType = (type) =>
    categories
      .filter((cat) => cat.category_type === type && cat.name !== "Cash Advance")
      .reduce((sum, cat) => sum + parseFloat(entryDataByCat[cat.id] || 0), 0);

  const incomeTotal = sumByType("income") + sumByType("non-sale");
  const paymentTotal = sumByType("payment");
  const refundTotal = sumByType("refunds");
  const paidoutsTotal = sumByType("paidouts") + cashAdvanceTotal;

  return (openAmount - closeAmount) + incomeTotal - paymentTotal - refundTotal - paidoutsTotal;
}


  const removeCashAdvanceRow = (date, index) => {
    setTempCashAdvanceData(prev => {
      const updated = { ...prev };
      if (!updated[date]) return updated;
      updated[date] = updated[date].filter((_, i) => i !== index);
      return updated;
    });
  };

  const nameExists = (name, exceptId = null) =>
  categories.some(
    (c) => c.name.toLowerCase() === name.trim().toLowerCase() && c.id !== exceptId
  );

const cannotTouch = (cat) =>
  !cat || cat.category_type === "till" || RESERVED.has(cat.name);

const editableCategories = categories.filter((c) => !cannotTouch(c));

const resetAddCat = () => setNewCat({ name: "", category_type: "" });
const resetEditCat = () => setEditCat({ id: "", name: "", category_type: "" });

const handleAddCategory = async (e) => {
  e.preventDefault();
  if (!newCat.name.trim() || !newCat.category_type) {
    alert("Enter name and select type.");
    return;
  }
  if (RESERVED.has(newCat.name.trim())) {
    alert("That name is reserved.");
    return;
  }
  if (nameExists(newCat.name)) {
    alert("Category name already exists.");
    return;
  }
  try {
    await api.post("/cash-register-categories", {
      name: newCat.name.trim(),
      category_type: newCat.category_type,
      business_id: businessId, // required by your POST route
    });
    await loadCategories();
    resetAddCat();
    setShowAddCat(false);
  } catch (err) {
    console.error("Add category error:", err);
    alert("Failed to add category");
  }
};


const fileInputRefCash = useRef(null);

// normalize helper (same as invoices idea)
const norm = (s="") => s.trim().toLowerCase();

const handleCashCsvUpload = (e) => {
  const file = e.target.files?.[0];
  if (!file) return;

  const byNorm = {};
  categories.forEach((c) => {
    byNorm[norm(c.name)] = c;
  });

  Papa.parse(file, {
    header: true,
    skipEmptyLines: true,
    transformHeader: (h) => (h || "").trim(),
    complete: async (res) => {
      try {
        const headers = res.meta?.fields || [];
        const data = Array.isArray(res.data) ? res.data : [];

        const dateHeader = headers.find((h) => norm(h) === "date");
        if (!dateHeader) {
          alert('Missing required "Date" column.');
          if (fileInputRefCash.current) fileInputRefCash.current.value = "";
          return;
        }

        // Match only valid category columns. Ignore extra unmatched columns.
        const RESERVED_HEADERS = new Set(["required cash", "cash advance"]);
        const mappings = [];
        const ignoredColumns = [];

        for (const h of headers) {
          const n = norm(h);
          if (!h || n === "date") continue;
          if (RESERVED_HEADERS.has(n)) continue;

          const cat = byNorm[n];

          // Ignore unmatched columns instead of failing
          if (!cat) {
            ignoredColumns.push(h);
            continue;
          }

          mappings.push({
            column: h,
            category_id: cat.id,
            category_name: cat.name,
          });
        }

        if (!mappings.length) {
          alert("No importable category columns found.");
          if (fileInputRefCash.current) fileInputRefCash.current.value = "";
          return;
        }

        const parseAmount = (v) => {
          const s = String(v == null ? "" : v)
            .trim()
            .replace(/[$,]/g, "");
          if (!s) return null;
          const n = parseFloat(s);
          return isNaN(n) ? null : Number(n.toFixed(2));
        };

        const entries = [];
        const seen = new Set();
        let duplicateFound = false;

        data.forEach((row, idx) => {
          if (duplicateFound) return;

          const rowNum = idx + 2;
          const date = String(row[dateHeader] || "").trim();
          if (!date) return;

          for (const m of mappings) {
            const amt = parseAmount(row[m.column]);
            if (amt === null) continue;

            const key = `${date}|${m.category_id}`;
            if (seen.has(key)) {
              alert(
                `Duplicate value for Date ${date} and Category "${m.category_name}" (CSV row ${rowNum}).`
              );
              duplicateFound = true;
              return;
            }

            seen.add(key);

            entries.push({
              entry_date: date,
              category_id: m.category_id,
              amount: amt,
            });
          }
        });

        if (duplicateFound) {
          if (fileInputRefCash.current) fileInputRefCash.current.value = "";
          return;
        }

        if (!entries.length) {
          alert("No numeric amounts found to import.");
          if (fileInputRefCash.current) fileInputRefCash.current.value = "";
          return;
        }

        await api.post("/cash-register-entries/import-json", {
          business_id: Number(businessId),
          entries,
        });

        let successMessage = `Imported ${entries.length} entries.`;
        if (ignoredColumns.length) {
          successMessage += ` Ignored columns: ${ignoredColumns.join(", ")}`;
        }

        alert(successMessage);

        setTempEntryData({});
        setTempCashAdvanceData({});
        await loadEntries();
      } catch (err) {
        console.error("Cash import failed:", err);
        const msg =
          err?.response?.data?.errors?.join("\n") ||
          err?.response?.data?.error ||
          "Import failed.";
        alert(msg);
      } finally {
        if (fileInputRefCash.current) fileInputRefCash.current.value = "";
      }
    },
    error: (err) => {
      console.error("CSV parse error:", err);
      alert("Failed to parse CSV.");
      if (fileInputRefCash.current) fileInputRefCash.current.value = "";
    },
  });
};





const handleEditCatSelect = (idStr) => {
  const id = parseInt(idStr, 10);
  const cat = categories.find((c) => c.id === id);
  if (!cat) return;
  if (cannotTouch(cat)) {
    alert("This category can’t be edited.");
    return;
  }
  setEditCat({ id: cat.id, name: cat.name, category_type: cat.category_type });
};


const handleJumpToDate = useCallback(() => {
  if (!startDateInput) return;
  const dt = parseISO(startDateInput);
  if (isNaN(dt.getTime())) return;
  setCurrentDate(dt);          // keeps your [-3..+3] window logic
  setShowDatePicker(false);
}, [startDateInput]);




const handleSaveEditedCategory = async (e) => {
  e.preventDefault();
  if (!editCat.id || !editCat.name.trim() || !editCat.category_type) {
    alert("Select a category and fill all fields.");
    return;
  }
  const original = categories.find((c) => c.id === editCat.id);
  if (cannotTouch(original)) {
    alert("This category can’t be edited.");
    return;
  }
  if (nameExists(editCat.name, editCat.id)) {
    alert("Another category with this name already exists.");
    return;
  }
  try {
    // your PUT route expects { name, category_type } only (user_id from token)
    await api.put(`/cash-register-categories/${editCat.id}`, {
      name: editCat.name.trim(),
      category_type: editCat.category_type,
    });
    await loadCategories();
    resetEditCat();
    setShowEditCat(false);
  } catch (err) {
    console.error("Update category error:", err);
    alert("Failed to update category");
  }
};

const handleDisableCategory = async () => {
  if (!editCat.id) {
    alert("Select a category first.");
    return;
  }
  const cat = categories.find((c) => c.id === editCat.id);
  if (cannotTouch(cat)) {
    alert("This category can’t be disabled.");
    return;
  }
  if (!window.confirm(`Disable "${cat.name}"?`)) return;

  try {
    // your disable route: no body (user_id from token)
    await api.put(`/cash-register-categories/${editCat.id}/disable`);
    await loadCategories();
    resetEditCat();
    setShowEditCat(false);
  } catch (err) {
    console.error("Disable category error:", err);
    alert("Failed to disable category");
  }
};




const handleNewEntriesForDate = async (date) => {
  const entriesToInsert = [];

  // Manual entry inserts
  Object.entries(tempEntryData).forEach(([key, value]) => {
    const [category_id, entryDate] = key.split("_");
    if (entryDate === date && value !== "") {
      entriesToInsert.push({
        category_id: parseInt(category_id),
        date,
        amount: parseFloat(value),
        notes: null,
      });
    }
  });

  // Cash advance inserts
  const cashAdvanceCat = categories.find(c => c.name === "Cash Advance");
  (tempCashAdvanceData[date] || []).forEach(row => {
    if (row.employee_id && row.amount) {
      entriesToInsert.push({
        category_id: cashAdvanceCat?.id,
        date,
        employee_id: parseInt(row.employee_id),
        amount: parseFloat(row.amount),
        notes: null,
      });
    }
  });

  

  // API call
  try {
    await api.post("/cash-register-entries", {
      business_id: businessId,
      entries: entriesToInsert,
    });
    await loadEntries();
    setTempEntryData(prev => {
     const updated = { ...prev };
     Object.keys(updated).forEach((k) => {
       const [, d] = k.split("_");
       if (d === date) delete updated[k];
     });
     return updated;
   });
   setTempCashAdvanceData(prev => {
     const updated = { ...prev };
     delete updated[date];
     return updated;
   });
  } catch (err) {
    console.error("Insert error:", err);
    alert("Failed to insert entries");
  }
};







const handleEditEntriesForDate = async (date) => {
  const entriesToUpdate = [];
  const entriesToInsert = [];

  // 1. Manual Entry Updates/Inserts
  Object.entries(tempEntryData).forEach(([key, value]) => {
    const [category_id, entryDate] = key.split("_");
    if (entryDate !== date) return;
    if (value === "") return;

    const parsedAmount = parseFloat(value);
    if (isNaN(parsedAmount)) return;

    const savedEntry = entryData[key];
    if (savedEntry?.id) {
      // Update existing entry
      entriesToUpdate.push({
        id: savedEntry.id,
        amount: parsedAmount,
        notes: null,
      });
    } else {
      // Insert new entry
      entriesToInsert.push({
        category_id: parseInt(category_id),
        date,
        amount: parsedAmount,
        notes: null,
      });
    }
  });

  // 2. Cash Advance Updates/Inserts
  const cashAdvanceCat = categories.find((c) => c.name === "Cash Advance");
  (tempCashAdvanceData[date] || []).forEach((row) => {
    if (!row.employee_id || !row.amount) return;
    const parsedAmount = parseFloat(row.amount);
    if (isNaN(parsedAmount)) return;

    if (row.id) {
      entriesToUpdate.push({
        id: row.id,
        employee_id: parseInt(row.employee_id),
        amount: parsedAmount,
        notes: null,
      });
    } else {
      entriesToInsert.push({
        category_id: cashAdvanceCat?.id,
        date,
        employee_id: parseInt(row.employee_id),
        amount: parsedAmount,
        notes: null,
      });
    }
  });

  // 3. Required Cash Calculation
  const requiredCashCat = categories.find((c) => c.name === "Required Cash");
  let requiredCashUpdate = null;

  if (requiredCashCat) {
    const entryDataByCat = {};
    categories.forEach((cat) => {
      if (cat.name === "Required Cash") return;
      const key = `${cat.id}_${date}`;
      const tempVal = tempEntryData[key];
      const savedVal = entryData[key]?.amount;
      entryDataByCat[cat.id] =
        tempVal !== undefined && tempVal !== ""
          ? parseFloat(tempVal)
          : savedVal !== undefined
          ? parseFloat(savedVal)
          : 0;
    });

    const totalCashAdvance = [
      ...(cashAdvanceData[date] || []),
      ...(tempCashAdvanceData[date] || []),
    ].reduce((sum, row) => sum + parseFloat(row.amount || 0), 0);

    const rcAmount = calculateRequiredCash(
      entryDataByCat,
      totalCashAdvance,
      categories
    );

    const savedRC = entryData[`${requiredCashCat.id}_${date}`];
    if (savedRC?.id) {
      requiredCashUpdate = {
        id: savedRC.id,
        amount: parseFloat(rcAmount.toFixed(2)),
        notes: "Auto-updated Required Cash",
      };
    }
  }

  // 4. Nothing to do?
  if (
    entriesToUpdate.length === 0 &&
    entriesToInsert.length === 0 &&
    !requiredCashUpdate
  ) {
    alert(`No editable entries found for ${date}`);
    return;
  }

  try {
    // Inserts for new categories on an existing day (with Required Cash update)
    if (entriesToInsert.length) {
      await api.post(
        "/cash-register-entries/insert-and-update-req-cash",
        {
          business_id: businessId,
          entries: entriesToInsert,
          required_cash_update: requiredCashUpdate,
        }
      );
    }

    // Updates for existing entries (including Required Cash only updates)
    if (entriesToUpdate.length && !entriesToInsert.length) {
      await api.put("/cash-register-entries", {
        business_id: businessId,
        entries: entriesToUpdate.concat(
          requiredCashUpdate ? [requiredCashUpdate] : []
        ),
      });
    }


    // Clear temporary state for this date
    setTempEntryData((prev) => {
      const updated = { ...prev };
      Object.keys(updated).forEach((key) => {
        const [, entryDate] = key.split("_");
        if (entryDate === date) delete updated[key];
      });
      return updated;
    });

    setTempCashAdvanceData((prev) => {
      const updated = { ...prev };
      delete updated[date];
      return updated;
    });

    await loadEntries();
  } catch (err) {
    console.error("❌ Edit error:", err);
    alert("Failed to save entries for this date");
  }
};



  const grouped = categories.reduce((acc, cat) => {
    if (!acc[cat.category_type]) acc[cat.category_type] = [];
    acc[cat.category_type].push(cat);
    return acc;
  }, {});

  if (grouped["till"]) {
    grouped["till"].sort((a, b) => {
      const order = ["Open Cash", "Close Cash"];
      return order.indexOf(a.name) - order.indexOf(b.name);
    });
  }

  const goLeft = () => setCurrentDate(prev => subDays(prev, 1));
  const goRight = () => setCurrentDate(prev => addDays(prev, 1));

  const cashAdvanceCat = categories.find(c => c.name === "Cash Advance");

  return (
    <div className="cash-entries-page">
      <h1 className="pw-page-title">Cash Entries</h1>
      
    



      <div className="cash-in-cat">
  <button onClick={() => setShowAddCat(true)}>+ Add Category</button>
  <button onClick={() => setShowEditCat(true)}>✏️ Edit / Disable Categories</button>
  <button onClick={() => fileInputRefCash.current?.click()}>
  Import Cash CSV
</button>
<input
  type="file"
  accept=".csv"
  ref={fileInputRefCash}
  style={{ display: "none" }}
  onChange={handleCashCsvUpload}
/>
   <button
      onClick={() => {
        setStartDateInput(format(currentDate, "yyyy-MM-dd"));
        setShowDatePicker((s) => !s);
      }}
      className="cash-jump"
      aria-label="Jump to date"
    >
      🗓️ Jump to date
    </button>
    {/* Put this where your toolbar buttons live */}



    <div className="cash-nav-center">
   

    {showDatePicker && (
      <span className="cash-jump-controls">
        <input
          type="date"
          value={startDateInput}
          onChange={(e) => setStartDateInput(e.target.value)}
        />
        <button onClick={handleJumpToDate}>Go</button>
        <button onClick={() => setShowDatePicker(false)} style={{background:"none", color: "red"}}><MdClose /></button>
      </span>
    )}
  </div>
</div>
<div className="cash-nav">
  <button className="left-nav-arrow" aria-label="Previous day" onClick={goLeft}><TbArrowBigLeftFilled /></button>

  

  <button className="right-nav-arrow" aria-label="Next day" onClick={goRight}><TbArrowBigRightFilled /></button>
</div>


      <div className="entries-grid" style={{ overflowX: "auto" }}>
        <table className="cash-entry-table" border="1" cellPadding="8" style={{ borderCollapse: "collapse", minWidth: "100%" }}>
          <thead>
            <tr>
              <th>Category</th>
              {daysToShow.map(date => (
                <th key={date}>{format(parseISO(date), "MMM d")}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {["till", "income", "non-sale", "payment", "paidouts", "refunds"].map(type =>
              grouped[type]?.map(cat => (
                cat.name === "Cash Advance" ? null : (
                  <tr key={cat.id}>
                    <td>{cat.name}</td>
                    {daysToShow.map(date => {
                      const savedEntry = entryData[`${cat.id}_${date}`];
                      return (
                        <td key={`${cat.id}_${date}`}>
                         {tempEntryData[`${cat.id}_${date}`] !== undefined ? (
  <input
    ref={(el) => {
    const k = `${cat.id}_${date}`;
    if (el) inputRefs.current[k] = el; else delete inputRefs.current[k];
  }}
    type="number"
    value={tempEntryData[`${cat.id}_${date}`] ?? ""}
    onKeyDown={(e) => handleKeyDown(e, cat.id, date)}
    onChange={(e) => handleInputChange(cat.id, date, e.target.value)}
    style={{ width: "70px" }}
  />
) : savedEntry ? (
  <>
    <span>${savedEntry.amount}</span>
    <button
      onClick={() => {
        setTempEntryData(prev => ({
          ...prev,
          [`${cat.id}_${date}`]: savedEntry.amount,
        }));
      }}
      style={{ marginLeft: "4px", background: "none", border: "none", color: "blue" }}
    >
      ✏️
    </button>
  </>
) : (
  <input
    ref={(el) => {
    const k = `${cat.id}_${date}`;
    if (el) inputRefs.current[k] = el; else delete inputRefs.current[k];
  }}
    type="number"
    value={tempEntryData[`${cat.id}_${date}`] ?? ""} 
    onKeyDown={(e) => handleKeyDown(e, cat.id, date)}
    onChange={(e) => handleInputChange(cat.id, date, e.target.value)}
    style={{ width: "80px" }}
  />
)}

                        </td>
                      );
                    })}
                  </tr>
                )
              ))
            )}

            {cashAdvanceCat && (
              <tr>
                <td><strong>Cash Advance</strong></td>
                {daysToShow.map(date => {
                  const displayCashAdvanceRows = tempCashAdvanceData[date] ?? cashAdvanceData[date] ?? [];
                  return (
                    <td key={`ca_${date}`}>
                      {displayCashAdvanceRows.map((entry, idx) => (
                        <div key={idx} className="cash-in-advance" style={{ marginBottom: "6px", display: "flex", gap: "4px", alignItems: "center" }}>
                          {entry.employee_name ? (
                            <>
                              <span>{entry.employee_name}: ${entry.amount}</span>
                              <button
                                onClick={() => {
                                  setTempCashAdvanceData(prev => {
                                    const updated = { ...prev };
                                    if (!updated[date]) updated[date] = [];
                                    updated[date].push({
                                      id: entry.id,
                                      employee_id: entry.employee_id,
                                      amount: entry.amount,
                                    });
                                    return updated;
                                  });
                                  setCashAdvanceData(prev => {
                                    const updated = { ...prev };
                                    updated[date] = updated[date].filter((_, i) => i !== idx);
                                    return updated;
                                  });
                                }}
                                style={{ background: "none", border: "none", color: "blue", marginLeft: "4px" }}
                              >
                                ✏️
                              </button>
                            </>
                          ) : (
                            <>
                              <select
                                value={entry.employee_id || ""}
                                onChange={(e) => handleCashAdvanceChange(date, idx, "employee_id", e.target.value)}
                                style={{ flex: 1 }}
                              >
                                <option value="">Select Employee</option>
                                {employees.map(emp => (
                                  <option key={emp.id} value={emp.id}>{emp.name}</option>
                                ))}
                              </select>
                              <input
                                type="number"
                                placeholder="Amount"
                                value={entry.amount || ""}
                                onChange={(e) => handleCashAdvanceChange(date, idx, "amount", e.target.value)}
                                style={{ width: "80px" }}
                              />
                              <button onClick={() => removeCashAdvanceRow(date, idx)} className="remove-advance">
                                −
                              </button>
                            </>
                          )}
                        </div>
                      ))}
                      <button
                        className="add-advance"
                        onClick={() => addCashAdvanceRow(date)}
                      >
                        + Add
                      </button>
                    </td>
                  );
                })}
              </tr>
            )}

            <tr>
              <td><strong>Required Cash</strong></td>
              {daysToShow.map(date => {
  
  const openCashCat = categories.find(c => c.name === "Open Cash");
const closeCashCat = categories.find(c => c.name === "Close Cash");

const openAmount = parseFloat(entryData[`${openCashCat?.id}_${date}`]?.amount || 0);
const closeAmount = parseFloat(entryData[`${closeCashCat?.id}_${date}`]?.amount || 0);

const sumByType = (type) => {
  return (grouped[type] || []).reduce((sum, cat) => {
    if (cat.name === "Cash Advance") return sum;
    const val = parseFloat(entryData[`${cat.id}_${date}`]?.amount || 0);
    return sum + (isNaN(val) ? 0 : val);
  }, 0);
};

const paidoutsTotal = (cashAdvanceData[date] || []).reduce((sum, row) => sum + parseFloat(row.amount || 0), 0) + sumByType('paidouts');
const incomeTotal = sumByType("income") + sumByType("non-sale");
const paymentTotal = sumByType('payment');
const refundTotal = sumByType('refunds');

const requiredCash = (openAmount - closeAmount) + incomeTotal - paymentTotal - refundTotal - paidoutsTotal;

return (
  <td key={`required_cash_${date}`}>
    <strong>${requiredCash.toFixed(2)}</strong>
  </td>
);

})}

            </tr>

            <tr>
              <td></td>
              {daysToShow.map(date => (
  <td key={`submit_${date}`}>
    <button className="cash-in-save" onClick={() => {
      const isNewDay = !Object.keys(entryData).some(k => k.includes(date));
      isNewDay
        ? handleNewEntriesForDate(date)
        : handleEditEntriesForDate(date);
    }}>
      Save
    </button>
  </td>
))}

            </tr>

          </tbody>
        </table>
      </div>
      {/* Add Category */}
{showAddCat && (
  <div className="cash-in-cat-pop">
    <div>
      <h3>Add Category</h3>
      <form onSubmit={handleAddCategory}>
        <div>
          <label>
            Name{" "}
            <input
              type="text"
              value={newCat.name}
              onChange={(e) => setNewCat((s) => ({ ...s, name: e.target.value }))}
            />
          </label>
        </div>
        <div>
          <label>
            Type{" "}
            <select
              value={newCat.category_type}
              onChange={(e) =>
                setNewCat((s) => ({ ...s, category_type: e.target.value }))
              }
            >
              <option value="">-- Select --</option>
              {CATEGORY_TYPES.map((t) => (
                   <option key={t.value} value={t.value}>{t.label}</option>
              ))}
            </select>
          </label>
        </div>
        <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
          <button type="button" onClick={() => { resetAddCat(); setShowAddCat(false); }}>
            Cancel
          </button>
          <button type="submit">Add</button>
        </div>
      </form>
    </div>
  </div>
)}

{/* Edit / Disable Category */}
{showEditCat && (
  <div className="cash-in-edit-pop">
    <div>
      <h3>Edit / Disable Category</h3>
      <form onSubmit={handleSaveEditedCategory}>
        <div>
          <label>
            Select{" "}
            <select
              value={editCat.id}
              onChange={(e) => handleEditCatSelect(e.target.value)}
            >
              <option value="">-- Choose --</option>
              {editableCategories.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name} ({c.category_type})
                </option>
              ))}
            </select>
          </label>
        </div>

        <div>
          <label>
            Name{" "}
            <input
              type="text"
              value={editCat.name}
              onChange={(e) => setEditCat((s) => ({ ...s, name: e.target.value }))}
            />
          </label>
        </div>

        <div>
          <label>
            Type{" "}
            <select
              value={editCat.category_type}
              onChange={(e) =>
                setEditCat((s) => ({ ...s, category_type: e.target.value }))
              }
            >
              <option value="">-- Select --</option>
              {CATEGORY_TYPES.map((t) => (
   <option key={t.value} value={t.value}>{t.label}</option>
 ))}
            </select>
          </label>
        </div>

        <div style={{ display: "flex", gap: 8, marginTop: 8, justifyContent: "space-between" }}>
          <button type="button" onClick={handleDisableCategory} style={{ color: "red" }}>
            Disable
          </button>
          <div style={{ display: "flex", gap: 8 }}>
            <button type="button" onClick={() => { resetEditCat(); setShowEditCat(false); }}>
              Cancel
            </button>
            <button type="submit">Save</button>
          </div>
        </div>
      </form>
      <div style={{ fontSize: 12, marginTop: 6 }}>
        Note: “Open Cash”, “Close Cash”, “Required Cash”, “Cash Advance”, and any “till” type cannot be edited or disabled.
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default CashEntriesPage;

